// Pure derivations over a guide concept shared by reader routes, Content Lab,
// and concept navigation. Promoted here on second use so no route imports
// another route's `_lib` (docs/PROJECT-STRUCTURE.md).
import type { GuideConcept } from "./guide-schema";

export function guideConceptNumber(index: number): string {
  return String(index + 1).padStart(2, "0");
}

export function guideConceptHasContent(concept: GuideConcept): boolean {
  return Boolean(
    concept.mainIdea.length > 0 ||
      concept.mainIdeaImage ||
      concept.howItWorks.length > 0 ||
      concept.video ||
      concept.guidance.length > 0 ||
      concept.furtherReading.some((resource) => resource.url),
  );
}
